import "./TheDoula.module.css";
import Header from "@/reusable_sections/Header";
import DesignedForGrowth from "./sections/DesignedForGrowth";
import PerformanceByTheNumbers from "./sections/PerformanceByTheNumbers";
import ShopTheLook from "./sections/ShopTheLook";
import ConsultationCTA from "./sections/ConsultationCTA";
import Footer from "@/reusable_sections/Footer";
export default function TheDoulaPage() {
  return <div>
      <Header />
      <DesignedForGrowth />
      <PerformanceByTheNumbers />
      <ShopTheLook />
      <ConsultationCTA />
      <Footer />
    </div>;
}